import { Component, OnInit, OnDestroy } from '@angular/core';

// --- PrimeNG ---
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	selector: 'app-orders-error-dialog',
	templateUrl: './orders-error-dialog.component.html',
	styleUrls: ['./orders-error-dialog.component.scss'],
})
export class OrdersErrorDialog implements OnInit, OnDestroy {
	constructor(
		public _ref: DynamicDialogRef,
		public _config: DynamicDialogConfig
	) {}

	ngOnInit(): void {}

	get dialogData() {
		return this._config.data;
	}

	onClose(confirmed?: boolean) {
		if (!confirmed) return this._ref.close();

		this._ref.close(true);
	}

	ngOnDestroy(): void {}
}
